import React, { FC, useState, useEffect } from 'react';
import { faChartLine } from '@fortawesome/free-solid-svg-icons/faChartLine';
import { faDiagramProject } from '@fortawesome/free-solid-svg-icons/faDiagramProject';
import { faShield } from '@fortawesome/free-solid-svg-icons/faShield';

import Allocations from 'buyside/components/presentation/JoinCapIntroPage/Allocations/allocations';
import BloombergExcerpt from 'buyside/components/presentation/JoinCapIntroPage/BloombergExcerpt/bloombergExcerpt';
import Hero from 'buyside/components/presentation/JoinCapIntroPage/Hero/hero';
import Link from 'buyside/components/presentation/Link/link';
import Showcase from 'buyside/components/presentation/JoinCapIntroPage/Showcase/showcase';

const { allocationPublications } = require('buyside/util/constantsFromRails.json');

import styles from './joinCapIntroPageStyles.scss';

const allocations = [
  {
    company: 'Ampfield Holdings',
    amount: '$5M',
    publicationFileUrl: allocationPublications[5],
    image: '/images/pro/marketing/ampfield_logo.png'
  },
  {
    company: 'Verdad Fund Advisors',
    amount: '$10M',
    publicationFileUrl: allocationPublications[0],
    image: '/images/pro/marketing/verdad_logo.png'
  },
  {
    company: 'Rhizome Capital Management',
    amount: '$10M',
    publicationFileUrl: allocationPublications[1],
    image: '/images/pro/marketing/rhizome_logo.png'
  },
  {
    company: 'KeyPoint Capital Management',
    amount: '$500K',
    publicationFileUrl: allocationPublications[3],
    image: '/images/pro/marketing/keypoint_logo.png'
  },
  {
    company: 'Wickapogue Structured Credit Fund',
    amount: '$2.75M',
    publicationFileUrl: allocationPublications[2],
    image: '/images/pro/marketing/wickapogue_logo.png'
  },
  {
    company: 'Selective Wealth Management',
    amount: '$5M',
    publicationFileUrl: allocationPublications[4],
    image: '/images/pro/marketing/selective_wealth_logo.png'
  }
];

const features = [
  {
    icon: faDiagramProject,
    title: 'Expand Your Pipeline',
    description:
      'Efficiently expand your investor pipeline by managing a fund profile page on SumZero Cap Intro.'
  },
  {
    icon: faShield,
    title: 'Share Fund Data',
    description:
      'Have your key materials/fund data selectively shared with a fast-growing group of vetted institutions in a fully compliant way.'
  },
  {
    icon: faChartLine,
    title: 'Retain Insights',
    description:
      'Leverage robust analytics to manage prospect list and retain insights on the marketability of your product.'
  }
];

const showcaseItems = {
  'Make a Great First Impression': [
    'Show prospective institutions how your fund is different.',
    "Massively expand your prospect list, eliminate frictional barriers to your documents and data, and present the full picture of your process, performance, and infrastructure to entities that can rapidly accelerate your firm's growth."
  ],
  'Meet Sophisticated Institutional Allocators': [
    'Experience broad-based exposure to a high-quality group of investors that radically change the trajectory of your fund.',
    'Search the group based on key investment mandate criteria.',
    "Get matched with allocators based on the quality of your fund's page.",
    'Reach out to allocators directly with our Introductions tool.'
  ],
  'Build a Data-Driven Investor Funnel': [
    "Glean insights on how the allocator community is reacting to your fund's pitch.",
    'Know what docs resonate most, and pick up key intel on which allocators are the most interested in your fund.'
  ]
};

const JoinCapIntroPage: FC = () => {
  const [isAtTop, setIsAtTop] = useState(true);

  useEffect(() => {
    const handleScroll = (): void => {
      setIsAtTop(window.scrollY < 165);
    };

    window.addEventListener('scroll', handleScroll);
    return (): void => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={styles.joinCapIntroPage}>
      <Hero features={features} />
      <Showcase showcaseItems={showcaseItems} />
      <Allocations allocations={allocations} />
      <BloombergExcerpt />
      <div className={styles.joinCapIntroPageHaveQuestions}>
        <h3>Have Questions?</h3>
        <p>
          Contact <Link to="mailto:access@sumzero.com">access@sumzero.com</Link> for any questions
          related to SumZero Cap Intro.
        </p>
      </div>
      {isAtTop ? (
        <div className={styles.joinCapIntroPageScrollDown}>
          <img src="/images/pro/scroll_down.gif" alt="Scroll down" />
          <p>Scroll Down To Learn More</p>
        </div>
      ) : null}
    </div>
  );
};

export default JoinCapIntroPage;
